export default {"src":"/_next/static/media/Github_Icon.94c7210f.svg","height":30,"width":32,"blurWidth":0,"blurHeight":0};